import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';
import { Subject } from "rxjs/Rx";

@Injectable()
export class AccountClientDetailsService {

	private apiUrl = globalConst.baseAPI;  // URL para web api
	public attachmentReload = new Subject<any>();
	public cobrancaReload = new Subject<boolean>();

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	releaseOrder(data) {
		return this.http
			.post(this.apiUrl + "/order/v1/postrequester", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	blockOrder(data) {
		return this.http
			.post(this.apiUrl + "/order/v1/postlistflowblock", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	releaseOrderCarregamento(data) {
		console.log("releaseOrderCarregamento", data);
		return this.http
			.post(this.apiUrl + "/order/v1/freeload", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	blockOrderCarregamento(data) {
		console.log("blockOrderCarregamento", data);
		return this.http
			.post(this.apiUrl + "/order/v1/blockload", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAccountClientOrdersPrazo(id, search, orderby, sort, page) {

		page = page * globalConst.paginationSkip;

		let obj = {
			ClienteId: id,
			OrdemVendaNumero: search
		}

		console.log("PRAZO OBJ", obj);

		return this.http
			.post(this.apiUrl + "accounts/v1/postterm/?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page + "", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClientOrdersVista(id, search, orderby, sort, page) {

		page = page * globalConst.paginationSkip;

		let obj = {
			ClienteId: id,
			OrdemVendaNumero: search
		}

		console.log("VISTA OBJ", obj);

		return this.http
			.post(this.apiUrl + "accounts/v1/postcash/?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page + "", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClientOrdersRetira(id, search, orderby, sort, page) {

		page = page * globalConst.paginationSkip;

		let obj = {
			ClienteId: id,
			OrdemVendaNumero: search
		}

		console.log("RETIRA OBJ", obj);

		return this.http
			.post(this.apiUrl + "accounts/v1/postpay/?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page + "", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClientDetails(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomer/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	checkProposalAvailable(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getproposalLCbyaccountclientvalidation/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getCreditProposal(clientID){
		return this.http
		.get(this.apiUrl + "accounts/v1/existproposal/" + clientID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json());
	}

	getProposalClient(idAccountClient, orderby, sort) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getproposalLCbyaccountclientpage/" + idAccountClient + "?$orderby=" + orderby + " " + sort + "", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getLiberacaoOv(idAccountClient, orderby, sort) {
		return this.http
			.get(this.apiUrl + "order/v1/getproposalOVbyaccountclientpage/" + idAccountClient + "?$orderby=" + orderby + " " + sort + "", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	accountHistory(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "accounts/v1/gethistoryaccountclient/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getClientTypes(token, tipoClienteID) {
		return this.http
			.get(this.apiUrl + "clienttypes/v1/getcodclienttypeaccount/" + tipoClienteID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAllClientTypes(token) {
		return this.http
			.get(this.apiUrl + "clienttypes/v1/getclienttypes?$filter=Ativo eq true&$orderby=Nome", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAccountClientComments(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "/comments/v1/listaccountscommentsid/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClientFinancialDetails(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "/financialaccounts/v1/getfinancial/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClientFinancialDetailsRaw(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "/financialaccounts/v1/getrawfinancial/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClientFinancialTitulos(token, idAccountClient) {
		return this.http
			.get(this.apiUrl + "/financialaccounts/v1/gettitlesfinancial/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getUserProfileByClient(accountClientId) {
		return this.http
			.get(this.apiUrl + "commercialstructurepaper/v1/getuserprofile/" + accountClientId, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getLcProposal(id) {
		return this.http
			.get(this.apiUrl + "proposalLC/v1/getproposalLC/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	searchAccountClientLogs(token: string, begindate, enddate, user: string, id: string) {

		var filter = {
			LogLevel: 4,
			Usuario: user,
			IDTransacao: id,
			DataInicio: begindate == '' ? begindate : new Date(begindate),
			DataFim: enddate == '' ? enddate : new Date(enddate)
		};

		return this.http
			.post(this.apiUrl + "/logs/v1/logsaccountclient", filter, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateClientDetails(token, idAccountClient, obj) {

		var params = {
			ID: idAccountClient,
			Nome: obj.Nome,
			Apelido: obj.Apelido,
			DataNascimentoFundacao: obj.DataNascimentoFundacao,
			Telefone: obj.Telefone,
			Bairro: obj.Bairro,
			CEP: obj.CEP,
			Endereco: obj.Endereco,
			Numero: obj.Numero,
			Complemento: obj.Complemento,
			Cidade: obj.Cidade,
			UF: obj.UF,
			Pais: obj.Pais,
			TipoClienteID: obj.TipoClienteID,
			SegmentoID: obj.SegmentoID,
			Email: obj.Email,
			AdiantamentoLC: obj.AdiantamentoLC,
			LiberacaoManual: obj.LiberacaoManual,
			ClientePremium: obj.ClientePremium,
			PropostaAlcadaID: obj.PropostaAlcadaID,
			PropostaAlcadaStatusID: obj.PropostaAlcadaStatusID,
			TOP10: obj.TOP10
		};

		return this.http.put(this.apiUrl + "/accounts/v1/updatecustomer", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	insertAccountPhone(token, objAccountPhone: any) {
		return this.http.post(this.apiUrl + "accountsphone/v1/insertaccountphones", objAccountPhone, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountPhone(token, idUser) {
		return this.http
			.get(this.apiUrl + "accountsphone/v1/getccountsphone/" + idUser, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAccountLimit(token, idUser) {
		return this.http
			.get(this.apiUrl + "financialaccounts/v1/getfinancialbylimit/" + idUser, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	insertComment(token, idAccountClient, descricao) {

		var params = {
			ContaClienteID: idAccountClient,
			Descricao: descricao
		};

		return this.http.post(this.apiUrl + "/comments/v1/insertaccountscomments", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAllSegmentTypes(token) {
		return this.http
			.get(this.apiUrl + "segments/v1/segments", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getAccountClientDetailsSegmento(token, idSegmento) {
		return this.http
			.get(this.apiUrl + "segments/v1/getsegmentaccount/" + idSegmento, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	setCustomermanual(token: string, data) {
		return this.http
			.post(this.apiUrl + "accounts/v1/postcustomermanual", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	setFinancialStatus(token: string, data) {
		return this.http
			.post(this.apiUrl + "financialaccounts/v1/enablefinancial", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	viaCEP(cep) {
		return this.http
			.get("https://viacep.com.br/ws/" + cep + "/json/")
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	checkNickName(token, nickname, id) {

		var url = '';

		if (nickname) {
			url = id + "/" + nickname + "/";
		} else {
			url = id;
		}

		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomerbynickname/" + url, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getClientTotals(id) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getordercustomersummary/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//Return an arrray of economic groups by user.
	getEconomicGroups(userID, empresaID) {
		let url;

		if (empresaID) {
			url = userID + "/" + empresaID;
		} else {
			url = userID;
		}

		return this.http
			.get(this.apiUrl + "/economicgroup/v1/getcodclient/" + url, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//Return an array of members by group
	getGroupMembers(groupID) {
		var params = {
			GrupoId: groupID
		};

		return this.http
			.post(this.apiUrl + "/groupsmembers/v1/postgroupsdetails/", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	checkTribunal(contaClienteID) {
		return this.http
			.get(this.apiUrl + "/courtoflaw/v1/checkaccount/" + contaClienteID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});		
	}

	requestTribunal(obj) {
		return this.http
			.post(this.apiUrl + "/courtoflaw/v1/insertcourtoflaw", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	checkSerasa(userID) {
		return this.http
			.get(this.apiUrl + "/serasa/v1/checkexist/" + userID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	requestSerasa(userID) {
		const tempObj = {
			ContaClienteID: userID
		}

		return this.http
			.post(this.apiUrl + "/serasa/v1/search", tempObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	requestSerasaByID(serasaID) {
		return this.http
			.get(this.apiUrl + "/serasa/v1/detailhistory/" + serasaID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getAccountClientIdByCode(token, code) {
		return this.http
			.get(this.apiUrl + "accounts/v1/getcustomeridbycode/" + code, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getClientAttachments(id) {
		return this.http
			.get(this.apiUrl + "attachment/v1/getattachmentbyclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateAttachClient(obj) {
		return this.http
			.post(this.apiUrl + "attachment/v1/updateattachment/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	uploadAttachClient(obj) {
		return this.http
			.post(this.apiUrl + "attachment/v1/uploadattachment/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	inactivateAttachment(id) {
		return this.http
			.delete(this.apiUrl + "attachment/v1/inactiveattachment/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}

	downloadAttachment(id) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.get(this.apiUrl + "attachment/v1/downloadattachment/" + id, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}

	downloadAttachmentZip(id) {
		let localStorageOptions = JSON.parse(localStorage.getItem('yara.connectionHeader'))
		const options = new RequestOptions({ headers: localStorageOptions.headers, responseType: ResponseContentType.Blob });
		return this.http
			.get(this.apiUrl + "attachment/v1/downloadzip/" + id, options)
			.map(res => {
				return new Blob([res.blob()], { type: "application/octet-stream" });
			});
	}

	saveSerasa(contaClienteId, value: number) {
		return this.http
			.put(this.apiUrl + "serasa/v1/updatestatus?tipoRestricao=" + value.toString(), { ContaClienteId: contaClienteId }, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateFinancial(obj) {
		return this.http
			.post(this.apiUrl + "financialaccounts/v1/updatefinancial", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateBillingConcept(obj) {
		return this.http
			.post(this.apiUrl + "financialaccounts/v1/updateconcept", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	reevaluateWallet(idAccountClient) {
		return this.http
			.get(this.apiUrl + "accounts/v1/reavaliar/" + idAccountClient, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	// ======================================= Cadastro de Garantias ======================================= \\

	searchNameByDoc(document) {
		var obj = {
			Documento: document
		}

		return this.http
			.post(this.apiUrl + "accounts/v1/searchcustomer/", obj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	saveClientGuarantee(obj) {
		return this.http
			.post(this.apiUrl + "guarantee/v1/insertlistguarantee", [obj], JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateClientGuarantee(obj) {
		return this.http
			.put(this.apiUrl + "guarantee/v1/updatelistguarantee", [obj], JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	getGuarantees(id) {
		var orderby = "DataCriacao";
		var sort = "asc";
		return this.http
			.get(this.apiUrl + "guarantee/v1/getguarantee/" + id + "/?$orderby=" + orderby + " " + sort + "&$filter=Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//========================================== Alçada Comercial ============================================

	createCommercialCompetence(clientID) {
		const objToSend = {
			ContaClienteID: clientID
		}
		return this.http
			.post(this.apiUrl + "/tradearea/v1/insert", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	validateProposalCommercialCompetence(clientID) {
		const objToSend = {
			ContaClienteID: clientID
		}
		return this.http
			.post(this.apiUrl + "/tradearea/v1/validateProposal", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	//=================================== End Of Alçada Comercial ===========================================

	getClientDeliveries(clientID, empresasID, tipoRemessaID) {
		const objToSend = {
			accountClientID: clientID,
			empresaID: empresasID,
			tipoRemessa: tipoRemessaID
		}
		return this.http
			.get(this.apiUrl + "order/v1/getclientdeliveries/" + objToSend.accountClientID + "/" + objToSend.empresaID + "/" + objToSend.tipoRemessa, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateLimits(objToSend) {
		return this.http
		.post(this.apiUrl + "/financialaccounts/v1/updatelimit", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	getBillingConceptList() {
		let orderby = "Nome";
		let sort = "asc";
		let page = 0;

		page = page * globalConst.paginationSkip;

		return this.http
			.get(this.apiUrl + "billingconcepts/v1/billingconcepts?$orderby=" + orderby + " " + sort + "&$top=" + globalConst.paginationSkip + "&$skip=" + page + "&$filter=Ativo eq true",JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
//=================================== Start Of Commercial Structure ===========================================
	getCtcByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "commercialstructure/v1/getctcbyaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getRepresentativeByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "representative/v1/getrepresentativeaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getDirectorByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "representative/v1/getdirectorbyaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}

	getManagerByAccountClient(id) {
		return this.http
			.get(this.apiUrl + "representative/v1/getmanagerbyaccountclient/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json());
	}
	
	getAccountClientStructureDetails(token, idAccountClient, rep, ctc, gc, dc) {
		var params = {
			CodigoPrincipal: idAccountClient,
			Representante: rep,
			CTC: ctc,
			GC: gc,
			DC: dc
		};

		return this.http
			.get(this.apiUrl + "/accounts/v1/searchbycomlstruc" + params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/service/account-client-edit/account-client-details.service.ts